import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendingUp, TrendingDown } from 'react-feather';
import Card from '../../ui/Card';

interface Props {
  growth: number;
}

const MonthlyGrowth: React.FC<Props> = ({ growth }) => {
  const { t } = useTranslation();

  return (
    <Card className="bg-gradient-to-br from-white to-gray-50">
      <h3 className="text-lg font-semibold mb-4">{t('dashboard.stats.monthlyGrowth')}</h3>
      <div className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200">
        <div className="flex items-center space-x-3">
          {growth >= 0 ? (
            <TrendingUp className="text-green-600 w-5 h-5" />
          ) : (
            <TrendingDown className="text-red-600 w-5 h-5" />
          )}
          <span className={`text-lg font-semibold ${growth >= 0 ? 'text-green-600' : 'text-red-600'}`}>
            {Math.abs(growth).toFixed(1)}%
          </span>
        </div>
        <span className="text-sm text-gray-500">{t('dashboard.stats.vsLastMonth')}</span>
      </div>
    </Card>
  );
};

export default MonthlyGrowth;